import moment from "moment";

export function mapRevenueToMonths(inputData) {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  
  // Extract revenue data from the first item in the array
  const revenueData = inputData[0]?.data || [];
  
  // Map each month to its corresponding revenue value
  return months.map((month, index) => ({
    month,
    revenue: revenueData[index] || 0
  }));
}

export function getDateRangeFromFilter(timeRange) {
  const endDate = moment().format("YYYY-MM-DD");

  switch (timeRange) {
    case "daily":
      return {
        startDate: moment().format("YYYY-MM-DD"),
        endDate,
      };
    case "weekly":
      return {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate,
      };
    case "quarterly":
      return {
        startDate: moment().subtract(3, "months").format("YYYY-MM-DD"),
        endDate,
      };
    case "bi-annually":
      return {
        startDate: moment().subtract(6, "months").format("YYYY-MM-DD"),
        endDate,
      };
    case "annually":
      return {
        startDate: moment().subtract(1, "year").format("YYYY-MM-DD"),
        endDate,
      };
    case "monthly":
    default:
      return {
        startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
        endDate,
      };
  }
}
